module.exports = __webpack_public_path__ + "media/mrs-fens-gaggles-mastered.2920ef5e.wav";